import { Discriminant } from '@features/product/components/Collection/Collection.types';
import { Product } from '@features/product/typings';

const BUNDLED_ACCESSORIES_COLLECTION_ID = '341369';
const IPHONE_SUBPRODUCTTYPE_ID = 2341;

export const shouldBeHiddenIPhoneAccessoryCollection = (
  discriminant: Discriminant,
  product: Product,
  isInVariation: boolean
): boolean => {
  return (
    isInVariation &&
    discriminant.referenceId === BUNDLED_ACCESSORIES_COLLECTION_ID &&
    product.subProductTypeId == IPHONE_SUBPRODUCTTYPE_ID
  );
};
